import { render, staticRenderFns } from "./AvatarStoryOutline.vue?vue&type=template&id=6d5a96ff&scoped=true&"
import script from "./AvatarStoryOutline.vue?vue&type=script&lang=ts&"
export * from "./AvatarStoryOutline.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarStoryOutline.vue?vue&type=style&index=0&id=6d5a96ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a96ff",
  null
  
)

export default component.exports